// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  query questions {
    questions {
      _id
      title
      description
      categories
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/questions.js